var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "admin superadmin hero is-light is-fullheight" },
    [
      _c("TheNavbar"),
      _c("div", { staticClass: "hero-body" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-narrow is-hidden-touch" }, [
            _c(
              "div",
              { staticClass: "menu-container is-flex has-text-white" },
              [_c("AppMenu", { staticClass: "sidebar navbar is-primary" })],
              1
            )
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "child-container" }, [_c("RouterView")], 1)
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }